import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'ambassadors',
		path: '/ambassadors',
		component: loadable(async () => import(/* webpackChunkName: "pages/ambassadors" */ './index'), {
			exportName: 'Ambassadors',
			fallback: Loading,
		}),
		// Deliberately no `restrictedAccess`: anyone with the link can reach this page.
		// `ssr.seo: false` below keeps it out of search results instead.
		//
		// The application form still resolves without posting anywhere (see
		// submitContractRequest), so an applicant is shown a thank-you while their details are
		// discarded — that must land before this URL reaches real creators.
		frame: {
			header: false,
			footer: true,
		},
		ssr: {
			enabled: true,
			// Deliberately false: keeps the page unlisted since it's no longer gated. Emits
			// <meta name="robots" content="noindex"> and adds /ambassadors to robots.txt Disallow.
			//
			// Flipping this alone won't index well at launch — there's no `pageTitle` or
			// `pageMetadata` yet, so add those (with `meta_tags` i18n strings) too.
			seo: false,
		},
	},
];
